import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/settings/public");
                setSettings(data);
            } catch {
                setSettings({});
            }
        })();
    }, []);

    return <SettingsContext.Provider value={{ settings }}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);
